'use client';

import React from 'react';
import AppIcon from '@/components/ui/AppIcon';

export type { IconProps } from '@/components/ui/AppIcon';

/**
 * Icon is a thin compatibility wrapper around AppIcon.
 * This avoids duplicate default exports while preserving existing imports.
 */
const Icon: React.FC<React.ComponentProps<typeof AppIcon>> = (props) => {
  return <AppIcon {...props} />;
};

export default Icon;
